module.exports = __webpack_public_path__ + "media/images/cv/screenshot_landing-ad397c0efc474e7dcff811f909fb2e11.jpg";